import { useState, Fragment } from 'react';
import { Dialog, Alert, Grid, Typography, Card } from '@mui/material';

import { ButtonComponent } from 'components/ui';
import { AdminApi } from 'api';

export const DeleteDomainModal = ({ open, domain = '', updateDomains = console.log, setRemoveDomain = console.log }) => {
  const [wait, setWait] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onCloseModal = (_, reason) => {
    if (reason === 'backdropClick' && wait) return;
    setRemoveDomain('');
  };

  const onDeleteDomain = async () => {
    setWait(true);
    AdminApi.deleteBlackListDomain(domain)
      .then(() => {
        updateDomains();
        onCloseModal();
      })
      .catch((e) => {
        setErrorMessage(e);
        setWait(false);
      });
  };

  return (
    <Dialog open={open} onClose={onCloseModal} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <Card sx={{ width: 320, padding: 4, paddingBottom: 5 }}>
        <Typography mb='12px' sx={{ marginBottom: 2 }} variant='h4'>
          Delete Domain
        </Typography>
        {errorMessage ? (
          <Alert severity='error'>{errorMessage}</Alert>
        ) : (
          <Fragment>
            <Typography mb='20px' variant='body2' component='p' color='text.secondary'>
              Are you sure to delete "{domain}" domain?
            </Typography>
            <Grid container justifyContent='space-between'>
              <ButtonComponent color='primary' variant='outlined' disabled={wait} onClick={onCloseModal} text='CANCEL' width={76} />
              <ButtonComponent color='primary' disabled={wait} onClick={onDeleteDomain} text='DELETE' width={184} />
            </Grid>
          </Fragment>
        )}
      </Card>
    </Dialog>
  );
};
